import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import InlineSpinner from 'components/atoms/Spinner/InlineSpinner';
import { productLink } from 'productLink';
import { urls } from '../productLinks';

const Button = ({ showPrice = false }) => {
  const { priceProduct } = useSelector((state) => state.siteInfo);

  const priceText = showPrice && priceProduct ? ` - ${priceProduct.gross}` : '';

  return (
    <button type='button' className='main-btn product-subscribe' style={{ marginTop: '0px', display: 'inline-block' }}>
      {priceProduct ? `BUY NOW${priceText}` : <InlineSpinner />}
    </button>
  );
};

export const ProductHeroButton = ({ isJapanese, language, userInfo }) => (
  <>
    {isJapanese
      ? (
        <a href={productLink} target='_blank' rel='noreferrer'>
          <Button />
        </a>
      )
      : (
        <a href={userInfo ? urls.checkout[language] : urls.login[language]} target='_blank' rel='noreferrer'>
          <Button showPrice />
        </a>
      )}
  </>
);

ProductHeroButton.propTypes = {
  isJapanese: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  userInfo: PropTypes.shape(),
};

Button.propTypes = {
  showPrice: PropTypes.bool,
};
